import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import Draggable from 'react-draggable';
import CreateContact from "./CreateContact";
import ContactDocumentList from "./ContactDocumentList";
import ContactNotesList from "./ContactNotes";
import ContactUserDefineFields from "./ContactUserDefineFields";
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
import CustomerContactService from "../../Controller/CustomerContactController";
import HelpSite from "../../../Common/HelpLink";
function CustomerDetail({ onClose, CustomerSites, ClientCompanyID, ClientContactID, onNext, onPrevious }) {

    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [activeTab, setActiveTab] = useState('tab-contactDetail');
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AdministrationSetting";
    //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    const [isLock, setIsLock] = useState(0);
    const UserID = localStorage.getItem("UserID");
    const [phone, setPhone] = useState();
    const [mobile, setMobile] = useState();
    const [Email, setEmail] = useState();
    const [tabCount, setTabCount] = useState(0);
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    useEffect(() => {
        if (ClientContactID > 0) {
            fetchCustomerContactDetail(ClientContactID);
        }

    }, [ClientContactID]);
    const [isMinimized, setIsMinimized] = useState(false);

    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const changeTab = (tab) => {
        setActiveTab(tab);
        handleTabClick(); // Increment count
    };
    const handleTabClick = () => {
        setTabCount(prevCount => prevCount + 1); // Increment the count when any tab is clicked
    };

    const fetchCustomerContactDetail = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (ClientContactID > 0) {
                const CustomerDetail = await CustomerContactService.GetCustomerContactByID(redirectCallback, ClientContactID);
                setPhone(CustomerDetail[0].Phone);
                setMobile(CustomerDetail[0].Mobile);
                setEmail(CustomerDetail[0].Email);
                if (CustomerDetail[0].isLock === 1 && CustomerDetail[0].LockBy != UserID) {
                    setIsLock(1);
                }
                else {
                    setIsLock(0);
                    await CustomerContactService.LockContact(ClientContactID);
                }
            }
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    const tabClass = (ClientContactID > 0) ? "nav-link" : "nav-link disabled";
    return (
        <div className="modal fade customerContactModal show d-block" id="customerContactModal" tabIndex="-1" aria-labelledby="customerContactModalLabel" aria-hidden="true" data-backdrop="static">

            <div className={`modal-dialog ${ClientCompanyID > 0 ? 'modal-lg' : 'modal-xl'}`}>
                <Draggable handle=".modal-header" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content">
                        <div className={`modal-header ${accordTheme}`}>
                            <h5 className="modal-title" id="largeModalLabel"> {ClientContactID > 0 ? 'Edit Contact' : 'Add Contact'}<strong style={{ fontSize: "14px", color: "red" }}> {isLock.toString() === "0" ? "" : "(Locked)"}</strong></h5>
                            <span>
                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize" >
                                    <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                </button>

                            </span>
                        </div>
                        {!isMinimized && (
                            <div className="modal-body" style={{ flex: "1" }}>
                                <div className="row vertical-pills-tab">
                                    <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "20px", marginRight: "25px", width: "100%", background: "#fff", borderBottom: "1px solid #d8e0e3" }}>
                                        <ul className="nav nav-tabs" style={{ border: "none", borderColor: "none" }}>
                                            <li className="nav-item">
                                                <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-contactDetail' ? 'active' : ''}`} data-toggle="pill" href="#tab-contactDetail" onClick={() => changeTab('tab-contactDetail')}>
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/contact_details.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Details</strong>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-contactDocument' ? 'active' : ''}`} data-toggle="pill" href="#tab-contactDocument" onClick={() => changeTab('tab-contactDocument')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/contact_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Documents</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/contact_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Documents</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            {/*  {isLock.toString() === "0" ? (
                                                 <a className={tabClass} data-toggle="pill" href="#tab-contactUDF">User Define Fields</a>
                                            ) : (
                                                <a className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                    User Define Fields
                                                </a>
                                            )}*/}
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-contactNotes' ? 'active' : ''}`} data-toggle="pill" href="#tab-contactNotes" onClick={() => changeTab('tab-contactNotes')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/contact_notes.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/contact_notes.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                        </ul>
                                        <div className="ml-auto">
                                            {activeTab === "tab-contactDetail" && (
                                                <HelpSite FormName="Contact Detail" Module="31" />
                                            )}
                                            {activeTab === "tab-contactDocument" && (
                                                <HelpSite FormName="Document" Module="31" />
                                            )}

                                            {activeTab === "tab-contactNotes" && (
                                                <HelpSite FormName="Communication History" Module="31" />
                                            )}

                                        </div>


                                    </div>
                                    <div className="col-sm-12 pl-0">
                                        <div className="tab-content p-3" id="v-pills-tabContent">
                                            <div className={`tab-pane fade ${activeTab === 'tab-contactDetail' ? 'show active' : ''}`} id="tab-contactDetail" role="tabpanel">
                                                <CreateContact ClientCompanyID={parseInt(ClientCompanyID, 10)} CustomerSites={CustomerSites} ClientContactID={ClientContactID} onClose={onClose} onNext={onNext} onPrevious={onPrevious} isLock={isLock} JobTab={tabCount} />
                                            </div>
                                            <div className={`tab-pane fade ${activeTab === 'tab-contactDocument' ? 'show active' : ''}`} id="tab-contactDocument" role="tabpanel">
                                                <ContactDocumentList ClientContactID={ClientContactID} isLock={isLock} />
                                            </div>
                                            <div className={`tab-pane fade ${activeTab === 'tab-contactUDF' ? 'show active' : ''}`} id="tab-contactUDF" role="tabpanel">
                                                <ContactUserDefineFields ClientContactID={ClientContactID} isLock={isLock} />
                                            </div>
                                            <div className={`tab-pane fade ${activeTab === 'tab-contactNotes' ? 'show active' : ''}`} id="tab-contactNotes" role="tabpanel">
                                                <ContactNotesList ClientContactID={ClientContactID} isLock={isLock} Phone={phone} Mobile={mobile} ToEmail={Email} JobTab={tabCount} />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default CustomerDetail;
